import { Stack } from "@mui/material";
import type { GridColDef } from "@mui/x-data-grid-premium";
import RecordCounter from "@entrilia/shared/components/filters/RecordCounter";
import FundraisingStatusTag from "@entrilia/shared/components/FundraisingStatusTag";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import GridTextHoverLink from "@entrilia/shared/components/grid/GridTextHoverLink";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { FundraisingInfo } from "../../../../api/types/fundraisingTypes";
import { ActionsCell } from "./fundraisingsGridProvider";
import PageDeactivatedAlert from "./PageDeactivatedAlert";

const columnDefinitions: GridColDef<FundraisingInfo>[] = [
  {
    field: "name",
    headerName: "Name",
    flex: 2,
    minWidth: 160,
    renderCell: ({ row }) => <GridTextHoverLink to={row.id} text={row.name} />,
  },
  {
    field: "fundName",
    headerName: "Fund",
    flex: 2,
    minWidth: 160,
  },
  {
    field: "status",
    headerName: "Status",
    flex: 1,
    minWidth: 160,
    renderCell: ({ row }) => <FundraisingStatusTag status={row.status} />,
  },
  {
    field: "documentCount",
    headerName: "Documents",
    type: "number",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "createdAt",
    headerName: "Created at",
    flex: 1,
    minWidth: 160,
    valueFormatter: (value: string) => (value ? convertISODateTime(value) : ""),
  },
  {
    field: "createdByUserName",
    headerName: "Created by",
    flex: 1,
    minWidth: 160,
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 144,
    align: "right",
    headerAlign: "right",
    cellClassName: "grid-row-actions",
    renderCell: ({ row }) => <ActionsCell row={row} />,
  },
];

interface Props {
  fundraisings: FundraisingInfo[];
  isLoading: boolean;
  showPageDeactivatedWarning: boolean;
}

const FundraisingsList = ({ fundraisings, isLoading, showPageDeactivatedWarning }: Props) => (
  <Stack spacing={2} sx={{ height: "100%" }}>
    {showPageDeactivatedWarning && <PageDeactivatedAlert />}
    <RecordCounter records={fundraisings.length} hide={isLoading} />
    <DataGrid<FundraisingInfo>
      rows={fundraisings}
      columns={columnDefinitions}
      loading={isLoading}
      noRowsText="No fundraisings yet"
      disableColumnReorder
      disableColumnSorting
    />
  </Stack>
);

export default FundraisingsList;
